import Index from './index.vue'
import Layout from './layout.vue'

const main_router = 'uploader'

const router = [
    {
        path: ':operation_identity?',
        component: Index,
        name: 'customer_uploader',
        meta: {
            breadcrumb: [main_router]
        }
    },
]
export default router
